// extracted by mini-css-extract-plugin
module.exports = {"main":"layout_main__4Hf4v","content":"layout_content__WDyRN","home_content":"layout_home_content__wP7CC"};